import { Receipt } from '@material-ui/icons';

interface Props {
  totalTickets: number;
  loading: boolean;
}

export const TotalTickets = ({ totalTickets, loading }: Props) => (
  <div className="inline-flex items-center justify-center col-span-full w-full px-6 py-2 gap-4 border-b border-border-light dark:border-border-dark">
    <Receipt fontSize="large" />
    <h5 className="text-2xl">
      {loading ? '-' : totalTickets}{' '}
      {totalTickets > 1 || totalTickets == 0 ? 'Tickets' : 'Ticket'}
    </h5>
  </div>
);
